import i18next from "i18next";
import { Button } from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";


export default function MeetingSlots({ slots, selectedDay, selectedTime, setSelectedSlot })
{
    const timeBlock = (day, slotTime) => {
        if (slots[day][slotTime].length == 0) return; //слот уже занят или нет свободных помещений
        const key = day + " " + slotTime;
        const isSelected = (day == selectedDay && slotTime == selectedTime);
        return (
            <Button 
                key={key} variant="outlined" size="large" disabled={isSelected} startIcon={isSelected ? <CheckBoxIcon /> : null}
                onClick={() => setSelectedSlot(day, slotTime)}
            >
                {slotTime}
            </Button>
        );
    }

    const dayBlock = day => {
        return (<div key={day}>
            <div className="meeting-day">{day}</div>
            {Object.keys(slots[day]).length > 0 
                ? Object.keys(slots[day]).map(slotTime => timeBlock(day, slotTime)) 
                : <div className="meeting-empty">{i18next.t("meeting_empty")}</div>}
        </div>);
    }

    return (<>
        {Object.keys(slots).length > 0 
            ? Object.keys(slots).map(dayBlock) 
            : <div className="meeting-empty">{i18next.t("meeting_empty")}</div>}
    </>);
}
